import React from 'react'
import { Carousel, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import GooglePlayButton from '../../Common/Buttons/GooglePlayButton'
import AppleStoreButton from '../../Common/Buttons/AppleStoreButton'
import './HeroCarousel.css'

const { Title, Paragraph } = Typography

const HeroCarousel: React.FC = () => {
    const { t } = useTranslation()

    return (
        <div className="hero-carousel">
            <Carousel
                dots={false}
                arrows={false}
                autoplay={false}
                className="hero-carousel-slider"
            >
                <div>
                    <div className="carousel-container">
                        <div className="carousel-content">
                            <Title className="title" level={1}>
                                {t('hero.title')}
                            </Title>
                            <Paragraph className="paragraph">
                                {t('hero.description')}
                            </Paragraph>
                            <div className="buttons">
                                <AppleStoreButton location="hero" />
                                <GooglePlayButton location="hero" />
                            </div>
                        </div>

                        <div className="carousel-gradient"></div>

                        <img
                            className="carousel-image"
                            src="/img/Cover.png"
                            alt={t('common.alt.peoplePlayingFootball')}
                        />
                    </div>
                </div>
            </Carousel>
        </div>
    )
}

export default HeroCarousel
